
//  //Twos day Sale ends Timers start

// document.addEventListener("DOMContentLoaded", function () {
//   // Enter the START Date of the sale here (YYYY-MM-DD):
//   const saleStartDate = "2026-07-21";

//   // The sale starts exactly at 11:00 AM IST on the start date
//   const startMs = new Date(`${saleStartDate}T11:00:00+05:30`).getTime();
//   // The sale ends exactly 24 hours later
//   const endMs = startMs + (24 * 60 * 60 * 1000);

//   function updateCountdown() {
//     const now = Date.now();

//     // If we are OUTSIDE the 24-hour sale window, show 00
//     if (now < startMs || now >= endMs) {
//       document.querySelectorAll('#days, #hours, #minutes, #seconds').forEach(el => el.innerText = '00');
//       return;
//     }

//     // We are INSIDE the 24-hour sale window, count down to the END of the sale
//     const distance = endMs - now;
//     const hours = Math.floor(distance / (1000 * 60 * 60));
//     const minutes = Math.floor((distance / (1000 * 60)) % 60);
//     const seconds = Math.floor((distance / 1000) % 60);

//     document.querySelectorAll('#days').forEach(el => el.innerText = '00');
//     document.querySelectorAll('#hours').forEach(el => el.innerText = String(hours).padStart(2, '0'));
//     document.querySelectorAll('#minutes').forEach(el => el.innerText = String(minutes).padStart(2, '0'));
//     document.querySelectorAll('#seconds').forEach(el => el.innerText = String(seconds).padStart(2, '0'));
//   }

//   updateCountdown();
//   setInterval(updateCountdown, 1000);
// });


//       if (document.body.classList.contains('template-product') && document.body.className.includes('twos-day-sale') ||
//           document.body.classList.contains('template-page') && window.location.pathname.includes('twos-day-sale')) {
//         (function(){
//           function getBundleVariantData() {
//             if (window._bundleVariantDataParsed) return window._bundleVariantDataParsed;
//             var script = document.getElementById('BundleVariantData');
//             if (script) {
//               try {
//                 window._bundleVariantDataParsed = JSON.parse(script.textContent);
//               } catch (e) {
//                 window._bundleVariantDataParsed = window.bundleVariantData || {};
//               }
//             } else {
//               window._bundleVariantDataParsed = window.bundleVariantData || {};
//             }
//             return window._bundleVariantDataParsed;
//           }

//           function populateSizeSelect(productHandle, sizeSelectEl, hiddenInputEl) {
//             if (!sizeSelectEl || !hiddenInputEl) return;

//             sizeSelectEl.innerHTML = '<option value="">Select Size</option>';
//             sizeSelectEl.disabled = true;
//             hiddenInputEl.value = "";

//             if (!productHandle) {
//               sizeSelectEl.dispatchEvent(new Event('change'));
//               return;
//             }

//             var variantDataObj = getBundleVariantData();
//             var variants = variantDataObj[productHandle] || [];

//             function renderOptions(variantList) {
//               sizeSelectEl.disabled = false;
//               variantList.forEach(function (v) {
//                 var o = document.createElement('option');
//                 o.value = v.id;

//                 var label = (v.title === "Default Title" || v.title === "Default title")
//                   ? "Free size"
//                   : v.title.replace('Sliders 2.0 / ', '');

//                 o.text = label;

//                 if (!v.available) {
//                   o.disabled = true;
//                   o.text += ' — Out of stock';
//                 }

//                 sizeSelectEl.appendChild(o);
//               });
//               sizeSelectEl.dispatchEvent(new Event('change'));
//             }

//             if (variants.length > 0) {
//               renderOptions(variants);
//             } else {
//               sizeSelectEl.disabled = true;
//               sizeSelectEl.innerHTML = '<option value="">Loading sizes...</option>';
//               fetch('/products/' + productHandle + '.js')
//                 .then(function(res) { return res.json(); })
//                 .then(function(product) {
//                   sizeSelectEl.innerHTML = '<option value="">Select Size</option>';
//                   if (product && product.variants) {
//                     variantDataObj[productHandle] = product.variants;
//                     renderOptions(product.variants);
//                   } else {
//                     sizeSelectEl.dispatchEvent(new Event('change'));
//                   }
//                 })
//                 .catch(function(err) {
//                   sizeSelectEl.innerHTML = '<option value="">Select Size</option>';
//                   sizeSelectEl.dispatchEvent(new Event('change'));
//                 });
//             }
//           }
//           function initBundle(bundleIndex) {
//             var block = document.querySelector('.bundle-block[data-bundle="'+bundleIndex+'"]');
//             if(!block) return;

//             var productSelect = block.querySelector('.bundle-product-select');
//             var sizeSelect    = block.querySelector('.bundle-size-select');
//             var hiddenInput   = block.querySelector('input[type="hidden"]');
//             var productError  = block.querySelector('.product-error');
//             var sizeError     = block.querySelector('.size-error');

//             if (!productSelect || !sizeSelect || !hiddenInput) return;

//             productSelect.addEventListener('change', function(){
//               productSelect.classList.remove('error-border');
//               if (productError) productError.style.display = 'none';

//               populateSizeSelect(productSelect.value, sizeSelect, hiddenInput);

//               sizeSelect.classList.remove('error-border');
//               if (sizeError) sizeError.style.display = 'none';

//               if (productSelect.value !== "") {
//                 productSelect.classList.add('selectbox_selected');
//               } else {
//                 productSelect.classList.remove('selectbox_selected');
//               }
//             });

//             sizeSelect.addEventListener('change', function(){
//               hiddenInput.value = sizeSelect.value || "";
//               sizeSelect.classList.remove('error-border');
//               if (sizeError) sizeError.style.display = 'none';

//               if (sizeSelect.value !== "") {
//                 sizeSelect.classList.add('selectbox_selected');
//               } else {
//                 sizeSelect.classList.remove('selectbox_selected');
//               }
//             });
//           }

//           function updateSelectedLabels(bundleIndex) {
//             const block = document.querySelector('.bundle-block[data-bundle="'+bundleIndex+'"]');
//             if(!block) return;

//             const productSelect = block.querySelector('.bundle-product-select');
//             const sizeSelect = block.querySelector('.bundle-size-select');

//             const productLabel = document.querySelector(`.bundle_selected_product${bundleIndex}`);
//             const sizeLabel = document.querySelector(`.bundle_selected_product${bundleIndex}_size`);

//             if (!productSelect || !sizeSelect) return;

//             // product
//             productSelect.addEventListener('change', function() {
//               if (productLabel) {
//                 const selectedText = productSelect.selectedIndex >= 0 ? productSelect.options[productSelect.selectedIndex].text : '';
//                 productLabel.textContent = (productSelect.value === "") ? "" : selectedText;
//               }
//             });

//             // size
//             sizeSelect.addEventListener('change', function() {
//               if (sizeLabel) {
//                 const selectedText = sizeSelect.selectedIndex >= 0 ? sizeSelect.options[sizeSelect.selectedIndex].text : '';
//                 sizeLabel.textContent = (sizeSelect.value === "") ? "" : selectedText;
//               }
//             });
//           }

//           initBundle(1);
//           initBundle(2);

//           updateSelectedLabels(1);
//           updateSelectedLabels(2);
//         })();
//         document.addEventListener("DOMContentLoaded", function () {

//           const priceBox = document.querySelector('.combine-price');
//           const select1 = document.getElementById('bundle_1_select');
//           const select2 = document.getElementById('bundle_2_select');

//           const premiumHandles = [
//             "circuit-shirt-2",
//             "circuit-shirt-1",
//             "circuit-shirt"
//           ];

//           function updateBundlePrice() {
//             if (!select1 || !select2) return;
//             const h1 = select1.value;
//             const h2 = select2.value;

//             // 🟡 DEFAULT PRICE when not selected
//             if (!h1 || !h2) {
//               if (priceBox) priceBox.innerHTML = "₹1,999";
//               return;
//             }

//             const isH1Premium = premiumHandles.includes(h1);
//             const isH2Premium = premiumHandles.includes(h2);

//             let price = 1999; // default when both NOT premium

//             // Any case where ONE or BOTH are premium → 1999
//             if (isH1Premium || isH2Premium) {
//               price = 1999;
//             }

//             if (priceBox) priceBox.innerHTML = `₹${price}`;
//           }

//           updateBundlePrice();

//           if (select1) select1.addEventListener("change", updateBundlePrice);
//           if (select2) select2.addEventListener("change", updateBundlePrice);

//         }); 

//         const spans = document.querySelectorAll(".bundle_selected_product1, .bundle_selected_product2");

//         spans.forEach((span) => {
//           const labelEl = span.closest(".label_selected");
//           if (!labelEl) return;
//           const text = labelEl.querySelector(".select-product-text");

//           const observer = new MutationObserver(() => {
//             if (text && span.textContent.trim().length > 0) {
//               text.style.display = "none";
//             }
//           });

//           observer.observe(span, {
//             childList: true,
//             subtree: true,
//             characterData: true
//           });
//         });
//       }

//       document.addEventListener('DOMContentLoaded', function() {

//         const bundleBtn = document.getElementById('bundleAddToCartBtn');

//         if (!bundleBtn) return;

//         bundleBtn.addEventListener('click', function() {

//           const bundles = [1, 2];
//           let errors = false;
//           const itemsToAdd = [];

//           bundles.forEach(index => {
//             const block = document.querySelector('.bundle-block[data-bundle="'+index+'"]');
//             if(!block) return;

//             const productSelect = block.querySelector('.bundle-product-select');
//             const sizeSelect = block.querySelector('.bundle-size-select');
//             const productError = block.querySelector('.product-error');
//             const sizeError = block.querySelector('.size-error');
//             const variantInput = block.querySelector('input[type="hidden"]');
//             const variant = variantInput ? variantInput.value : '';

//             if (productSelect && productSelect.value === "") {
//               if (productError) productError.style.display = 'block';
//               productSelect.classList.add('error-border');
//               errors = true;
//               return;
//             }

//             if (variant === "") {
//               if (sizeError) sizeError.style.display = 'block';
//               if (sizeSelect) sizeSelect.classList.add('error-border');
//               errors = true;
//               return;
//             }

//             if (variant) {
//               itemsToAdd.push({ id: variant, quantity: 1 });
//             }
//           });

//           if (errors) return;

//           // optimistic feedback: show banner (and bump count) immediately
//           if (typeof showAddToCartMessageGlobal === 'function') showAddToCartMessageGlobal();

//           fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ items: itemsToAdd })
//           })
//           .then(res => res.json())
//           .then(data => {
//             // 🔥 FACEBOOK ADD TO CART EVENT FOR EACH ITEM
//             if (typeof fbq !== 'undefined' && data.items) {
//               data.items.forEach(item => {
//                 fbq('track', 'AddToCart', {
//                   content_ids: [item.product_id],
//                   content_type: 'product',
//                   value: item.price / 100,
//                   currency: Shopify.currency.active
//                 });
//               });
//             }
//             render_cart();
//             // server response already came back; ensure bubble matches
//             if (typeof updateCartIconBubble === 'function') updateCartIconBubble(data.item_count);
//             // drawer opening suppressed per requirements
//             $('new-cart-drawer').addClass('active animate');
//           })
//           .catch(err => {
//             console.error("Error adding bundle items to cart:", err);
//           });

//         }); 
//       }); 



document.addEventListener("DOMContentLoaded", function () {

  /* ==========================================
     SALE TIMER CONFIGURATION
     (Synchronize date and time with sections/twos-day-sale.liquid)
  ========================================== */
  const saleStartDate = "2026-10-20";
  const saleStartTime = "10:59:00"; // Aligned with landing page redirection time
  const startMs = new Date(`${saleStartDate}T${saleStartTime}+05:30`).getTime();
  const endMs = startMs + (24 * 60 * 60 * 1000);

  function updateCountdown() {
    const now = Date.now();

    if (now < startMs || now >= endMs) {
      document.querySelectorAll('#days, #hours, #minutes, #seconds')
        .forEach(el => el.innerText = '00');
      return;
    }

    const distance = endMs - now;
    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance / (1000 * 60)) % 60);
    const seconds = Math.floor((distance / 1000) % 60);

    document.querySelectorAll('#days').forEach(el => el.innerText = '00');
    document.querySelectorAll('#hours').forEach(el => el.innerText = String(hours).padStart(2, '0'));
    document.querySelectorAll('#minutes').forEach(el => el.innerText = String(minutes).padStart(2, '0'));
    document.querySelectorAll('#seconds').forEach(el => el.innerText = String(seconds).padStart(2, '0'));
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

  /* =========================
     SAFE BUNDLE SYSTEM
     (removed dynamic product JS fetch)
  ========================== */

  function getVariantData() {
    const script = document.getElementById('BundleVariantData');

    try {
      return script ? JSON.parse(script.textContent) : (window.bundleVariantData || {});
    } catch (e) {
      return window.bundleVariantData || {};
    }
  }

  function populateSizeSelect(productHandle, sizeSelectEl, hiddenInputEl) {
    if (!sizeSelectEl || !hiddenInputEl) return;

    sizeSelectEl.innerHTML = '<option value="">Select Size</option>';
    sizeSelectEl.disabled = true;
    hiddenInputEl.value = "";
    sizeSelectEl.dispatchEvent(new Event('change'));

    if (!productHandle) return;

    const variantData = getVariantData();
    const variants = variantData[productHandle] || [];

    if (!variants.length) return;

    sizeSelectEl.disabled = false;

    variants.forEach(v => {
      const opt = document.createElement('option');
      opt.value = v.id;

      const label = (v.title === "Default Title")
        ? "Free size"
        : v.title.replace('Sliders 2.0 / ', '');

      opt.textContent = v.available ? label : `${label} — Out of stock`;
      opt.disabled = !v.available;

      sizeSelectEl.appendChild(opt);
    });
    sizeSelectEl.dispatchEvent(new Event('change'));
  }

  function checkBundleSelection() {
    const bundleBtn = document.getElementById('bundleAddToCartBtn');
    if (!bundleBtn) return;

    let allValid = true;
    [1, 2].forEach(i => {
      const block = document.querySelector(`.bundle-block[data-bundle="${i}"]`);
      if (!block) return;

      const productSelect = block.querySelector('.bundle-product-select');
      const sizeSelect = block.querySelector('.bundle-size-select');
      const hiddenInput = block.querySelector('input[type="hidden"]');

      if (!productSelect || !sizeSelect || !hiddenInput || !productSelect.value || !sizeSelect.value || !hiddenInput.value) {
        allValid = false;
      }
    });

    bundleBtn.disabled = !allValid;
  }

  function initBundle(index) {
    const block = document.querySelector(`.bundle-block[data-bundle="${index}"]`);
    if (!block) return;

    const productSelect = block.querySelector('.bundle-product-select');
    const sizeSelect = block.querySelector('.bundle-size-select');
    const hiddenInput = block.querySelector('input[type="hidden"]');

    if (!productSelect || !sizeSelect || !hiddenInput) return;

    productSelect.addEventListener('change', function () {
      populateSizeSelect(productSelect.value, sizeSelect, hiddenInput);
      checkBundleSelection();
    });

    sizeSelect.addEventListener('change', function () {
      hiddenInput.value = sizeSelect.value || "";
      checkBundleSelection();
    });
  }

  function updateSelectedLabels(bundleIndex) {
    const block = document.querySelector(`.bundle-block[data-bundle="${bundleIndex}"]`);
    if (!block) return;

    const productSelect = block.querySelector('.bundle-product-select');
    const sizeSelect = block.querySelector('.bundle-size-select');
    const productLabel = document.querySelector(`.bundle_selected_product${bundleIndex}`);
    const sizeLabel = document.querySelector(`.bundle_selected_product${bundleIndex}_size`);

    if (productSelect && productLabel) {
      function refreshProductLabel() {
        const selectedText = productSelect.selectedIndex >= 0 ? productSelect.options[productSelect.selectedIndex].text : '';
        productLabel.textContent = (productSelect.value === "") ? "" : selectedText.trim();
        if (productSelect.value !== "") {
          productSelect.classList.add('selectbox_selected');
        } else {
          productSelect.classList.remove('selectbox_selected');
        }
      }
      productSelect.addEventListener('change', refreshProductLabel);
      refreshProductLabel();
    }

    if (sizeSelect && sizeLabel) {
      function refreshSizeLabel() {
        const selectedText = sizeSelect.selectedIndex >= 0 ? sizeSelect.options[sizeSelect.selectedIndex].text : '';
        sizeLabel.textContent = (sizeSelect.value === "") ? "" : selectedText.trim();
        if (sizeSelect.value !== "") {
          sizeSelect.classList.add('selectbox_selected');
        } else {
          sizeSelect.classList.remove('selectbox_selected');
        }
      }
      sizeSelect.addEventListener('change', refreshSizeLabel);
      refreshSizeLabel();
    }
  }

  initBundle(1);
  initBundle(2);

  updateSelectedLabels(1);
  updateSelectedLabels(2);
  checkBundleSelection();

  const spans = document.querySelectorAll(".bundle_selected_product1, .bundle_selected_product2");
  spans.forEach((span) => {
    const labelEl = span.closest(".label_selected");
    if (!labelEl) return;
    const text = labelEl.querySelector(".select-product-text");
    if (!text) return;

    function toggleSelectText() {
      if (span.textContent.trim().length > 0) {
        text.style.display = "none";
      } else {
        text.style.display = "";
      }
    }

    const observer = new MutationObserver(toggleSelectText);
    observer.observe(span, {
      childList: true,
      subtree: true,
      characterData: true
    });
    toggleSelectText();
  });

  /* =========================
     PRICE LOGIC (Dynamic from backend price or fallback)
  ========================== */

  const priceBox = document.querySelector('.combine-price');
  const select1 = document.getElementById('bundle_1_select');
  const select2 = document.getElementById('bundle_2_select');

  // Dynamic price from product backend via dataset, fallback to existing text or hard-coded default
  const defaultPrice = (priceBox && priceBox.dataset.dynamicPrice) 
    ? priceBox.dataset.dynamicPrice 
    : (priceBox && priceBox.textContent.trim() ? priceBox.textContent.trim() : "₹ 1,499");

  const premiumHandles = [
    "circuit-shirt-2",
    "circuit-shirt-1",
    "circuit-shirt"
  ];

  function updateBundlePrice() {
    if (!priceBox) return;

    if (!select1?.value || !select2?.value) {
      priceBox.innerHTML = defaultPrice;
      return;
    }

    const isPremium =
      premiumHandles.includes(select1.value) ||
      premiumHandles.includes(select2.value);

    priceBox.innerHTML = isPremium ? defaultPrice : defaultPrice;
  }

  updateBundlePrice();
  select1?.addEventListener("change", updateBundlePrice);
  select2?.addEventListener("change", updateBundlePrice);

});


/* =========================
   ADD TO CART (clean + stable)
========================= */

document.addEventListener('DOMContentLoaded', function () {

  const bundleBtn = document.getElementById('bundleAddToCartBtn');
  if (!bundleBtn) return;

  bundleBtn.addEventListener('click', async function () {

    const bundles = [1, 2];
    const items = [];
    let error = false;

    bundles.forEach(i => {
      const block = document.querySelector(`.bundle-block[data-bundle="${i}"]`);
      if (!block) return;

      const hidden = block.querySelector('input[type="hidden"]');

      if (!hidden?.value) {
        error = true;
        return;
      }

      items.push({ id: hidden.value, quantity: 1 });
    });

    if (error) return;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      const data = await res.json();

      if (typeof render_cart === 'function') render_cart();
      if (typeof updateCartIconBubble === 'function') updateCartIconBubble(data.item_count);

      document.querySelector('new-cart-drawer')?.classList.add('active', 'animate');

    } catch (err) {
      console.error("Cart error:", err);
    }

  });

});